<template>
	<div class="player">
		<nav class="navbar navbar-expand navbar-light bg-primary">
			<div class="" id="navbarSupportedContent">
				<ul class="navbar-nav mr-auto">
					<li class="nav-item dropdown " :class="{ 'show': show }">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" @click.prevent.stop="show = !show">
							{{format_label}}
						</a>
						<div class="dropdown-menu " :class="{ 'show': show }" aria-labelledby="navbarDropdown">
							<span class="dropdown-item pointer" :class="{ 'active': format === null }" @click.stop="changeFormat(null)">AUTO</span>
							<span class="dropdown-item pointer" v-if="isRTMP" :class="{ 'active': format === 'rtmp' }" @click.stop="changeFormat('rtmp')">RTMP</span>
							<span class="dropdown-item pointer" v-if="isHLS" :class="{ 'active': format === 'hls' }" @click.stop="changeFormat('hls')">HLS</span>
						</div>
					</li>
				</ul>
			</div>
		</nav>

		<div class="player__outer">
			<div :id="id" class="player__wrapper">

			</div>
		</div>

		<div class="alert alert-info" v-if="stage_state.hlsNote">
			Now you use HLS video stream and it have delay of 20 seconds.
			<span v-if="!stage_state.flash">
				To see 'online' video please <router-link :to="{name: 'flash', query: { redirect: path } }">enable</router-link> Flash Player on page.
			</span>
		</div>
		<div class="alert alert-warning" v-if="stage_state.flashError">
			Selected stream type could not start, because Flash player is not available.
			<span v-if="!isHLS">This stream only available in RTMP that require Flash Player.</span>
			Please <router-link :to="{name: 'flash', query: { redirect: path } }">enable</router-link> Flash to see this stream.
		</div>

		<!--<div>

			<pre>
				{{stage_state}}
			</pre>
		</div>-->
	</div>
</template>

<script>
	require('@/plugins/jwplayer/jwplayer.js');



	//script type="text/javascript" src="/themes/germantote/js/jwplayer/jwplayer.js"
//


	export default {
		name: "player",
		props:{
			stream:{
				type: Object
			}
		},
		data(){
			return{
				id: '',
				format: null,
				show: false
				/*stream:{
					rtmp: 'rtmp://sorec-streaming.archostechnology.net:1935/live/OutStream1_720p',// 'rtmp://cp559122.live.edgefcs.net/live/gbi_racing@s458792?auth=daEbPcUd4bFaIbVasdhbeaDaybNb6dhb9aZ-bCTivr-vga-qE_FDuow&aifp=abcd',
					hls: 'http://sorec-streaming.archostechnology.net:1935/live/OutStream1/playlist.m3u8',//'https://gt2-i.akamaihd.net/hls/live/266246/German_Tote_1/1/01.m3u8?hdntl=exp=1555420799~acl=/!*~data=hdntl~hmac=37a29dd51999a67ca8012cac4b1947bf5462c563d4004b771e57a769226e76f6'
				}*/
			}
		},
		watch: {
			stream(){
				this.reload();
				this.format = null;
			},
			format(){
				this.reload();
			}
		},
		beforeDestroy(){
			this.destroy();
		},
		computed:{
			path(){
				return this.$route.path;
			},


			/*player_settings: {
				get(){
					return this.$store.state.player_settings;
				},
				set(value){

					this.$store.commit('setPlayerSettings', value)
				}
			},*/

			stream_config(){

				let conf = {
					'file': '',
					'width': "100%",
					'aspectratio': "16:9",
					'autostart': 'true',
					'preload':'none',
					'type': '',
					'primary': 'html5'
				};
				conf.file = this.stream[this.stage_state.type];
				conf.type = this.stage_state.type;

				return conf;
			},

			format_label(){
				switch (this.format) {
					case null:
						return 'AUTO ('+this.stage_state.type.toUpperCase()+')';
					case 'rtmp':
						return 'RTMP';
					case 'hls':
						return 'HLS';
				}
				return '';
			},

			stage_state(){
				let state = {
					flash: this.isFlash,
					type: 'rtmp/hls',
					flashError: false, //Flash disabled or absent in system
					hlsNote: false, //HLS stream have 20 seconds delay, but only if FLASH available + rtmp
					rtmpError: false, //RTMP not available

				};

				//DEFAULT
				if(this.format === null){


					if(this.isRTMP && this.isFlash){
						state.type = 'rtmp';
						return state;
					}else if (this.isRTMP && this.isHLS){
						state.type = 'hls';
						state.hlsNote = true;
						return state;
					}else if (this.isRTMP && !this.isHLS){
						state.type = 'rtmp';
						state.flashError = true;
						return state;
					}else{
						state.type = 'hls';
						return state;
					}

				//RTMP
				}else if(this.format === 'rtmp'){

					if(this.isRTMP && this.isFlash){
						state.type = 'rtmp';
						return state;
					}else if(this.isRTMP && this.isHLS){
						state.type = 'hls';
						state.hlsNote = true;
						state.flashError = true;
						return state;
					}else if (this.isRTMP && !this.isHLS){
						state.type = 'rtmp';
						state.flashError = true;
						return state;
					}else{
						state.type = 'hls';
						return state;
					}

				//HLS
				}else if(this.format === 'hls'){

					if(this.isHLS){
						state.type = 'hls';
						state.hlsNote = true;
						return state;
					}else if(this.isRTMP && this.isFlash){
						state.type = 'rtmp';
						return state;
					}else if(this.isRTMP){
						state.type = 'rtmp';
						state.flashError = true;
						return state;
					}
				}

				return null;

			},

			isFlash()
			{
				let flash = navigator.plugins.namedItem('Shockwave Flash') ;
				return flash !== null && typeof flash === 'object';
			},
			isRTMP(){
				//check availability of rtmp url in stream data feed
				return this.stream.rtmp !== '';
			},
			isHLS(){
				//check availability of hls url in stream data feed
				return this.stream.hls !== '';
			}
		},
		mounted(){

			window.pl = this;

			this.id = this.localRandomString();

			window.jwplayer.key="fYbTvX5HHEnKfIBtb6eKyyVNelrBt6y8sa5M//vOssk=";

			this.setup();


			/*
			*
			* 'rtmp': 'rtmp://cp557783.live.edgefcs.net/live/german_tote#_1@s458720?auth=daEa9a4bNaadDdDdzd7aubVc8agd1bUdca8-bCThZ7-vga-qC_DGtnz&aifp=abcd',
							'hls': 'https://gt2-i.akamaihd.net/hls/live/266246/German_Tote_1/master.m3u8?hdnts=st=1555332347~exp=1555335947~acl=/*~hmac=24717e56f9bbce174f3055e00c159573a71e2e542849efe4bd876dad55f7caea'
			*
			* */

		},
		methods:{

			setup(){
				this.$nextTick(()=>{
					window.jwplayer(this.id).setup(this.stream_config).on('error', (event)=>{

						//Fallback if RTMP stream is failed
						if(event.type === 'error' && this.isHLS && this.stage_state.type === 'rtmp' && this.format === null){
							this.format = 'hls';
						}
					});
				});
			},

			destroy(){

				window.jwplayer(this.id).remove();
			},

			reload(){
				this.destroy();
				setTimeout(()=>{
					this.setup();
				},150);
			},

			changeFormat(format){

				this.show = false;
				this.format = format;
			}


		}
	}
</script>

<style scoped>

</style>